export const GaEvents = {
  closeModal: 'Close Login Modal',
  tncTap: 'fe_login_tc_tap',
  formSubmit: {
    login: 'Login Mobile Number',
    signup: 'Registration New User',
    otp: 'Verify OTP',
  },
  ctaTap: {
    'login': 'fe_login_cta_confirm_tap',
    'otp': 'fe_loginotp_cta_confirm_tap',
    'signup': 'fe_loginsignup_cta_confirm_tap',
    'tnc-consent': 'fe_login_consent_confirm_tap',
  },
  newUserSignup: 'fe_loginotp_registration',
  newUserSignupFail: 'fe_loginotp_reg_check_failed',
  resendOtpCtaTap: 'Resend OTP Verification',
  resendSubmit: 'Resend Button Click',
  pageLand: {
    login: 'fe_login_land',
    signup: 'fe_loginsignup_land',
    otp: 'fe_loginotp_land',
  },
  consentTap: {
    noConsent: 'fe_login_no_whatsapp_consent',
    yesConsent: 'fe_login_re_whatsapp_consent',
  },
  changeNumber: 'Change Login Number',
} as const;

export const MoeEvents = {
  ctaTap: {
    'login': 'fe_login_cta_confirm_tap_moe',
    'otp': 'Verify OTP_moe',
    'signup': 'fe_loginsignup_cta_confirm_tap_moe',
    'tnc-consent': 'fe_login_consent_confirm_tap_moe',
  },
  pageLand: {
    login: 'fe_login_land_moe',
    signup: 'fe_loginsignup_land_moe',
    otp: 'fe_loginotp_land_moe',
  },
} as const;
